var map = {
	"./collection.js": "./src/config/reducers/collection.js",
	"./feature.js": "./src/config/reducers/feature.js",
	"./scope.js": "./src/config/reducers/scope.js",
	"./selector.js": "./src/config/reducers/selector.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;



//////////////////
// WEBPACK FOOTER
// ./src/config/reducers nonrecursive \.js$
// module id = 115
// module chunks = 0 1